import SubTitle from 'components/UI/sub-title/sub-title'
import Title from 'components/UI/title/title'
import React, { useContext, useEffect, useState } from 'react'
import tw from 'twin.macro'

const denominations = [
  {
    value: '10000',
    label: '10 000 ₸'
  },
  {
    value: '20000',
    label: '20 000 ₸'
  },
  {
    value: '50000',
    label: '50 000 ₸'
  },
  {
    value: '100000',
    label: '100 000 ₸'
  },
  {
    value: '200000',
    label: '200 000 ₸'
  }
]

import CardLimitIcon from 'assets/icons/CardLimitIcon'
import { Button } from 'components/UI/button/button'
import Modal from 'components/UI/modal/modal'
import { ThemeContext } from 'contexts/theme-context'
import CurrencyFormat from 'react-currency-format'
import { useTranslation } from 'react-i18next'
import { useGetProductsQuery } from 'redux/api/buy-card.api'

import GreenGradient from './../../assets/images/benefits-container-5-green-gradient.webp'
import MegaSyiliq from './../../assets/images/nominal-img.webp'
import MegaSyiliqDark from './../../assets/images/nominal-img-dark.webp'
import AuthModal from './auth-modal'
import BuyCardModal from './buy-card-modal'
function LandingBuyCardContainer() {
  const { data, isLoading, error } = useGetProductsQuery(null)
  const [open, setOpen] = useState<boolean>(false)
  const [active, setActive] = useState<{ product_code: string; amount: string } | null>({
    amount: '',
    product_code: ''
  })
  const { t } = useTranslation()
  const { theme } = useContext(ThemeContext)
  const handleCloseModal = () => {
    setOpen(false)
  }
  const handleBuyCard = () => {
    setOpen(true)
  }

  useEffect(() => {
    if (data) {
      setActive(data?.data.products[0])
    }
  }, [data])

  return (
    <>
      <div tw='bg-secondary rounded-s32 pt-10 px-10 relative gap-2 overflow-hidden w-full flex justify-between sm:w-[744px] sm:h-auto h-[780px] sm:p-[32px] '>
        <img src={GreenGradient} alt='' tw='absolute bottom-0 right-0' />
        <div tw='flex flex-col sm:justify-between relative z-20 sm:gap-[32px] gap-[24px] w-full '>
          {error ? (
            <div>
              <Title variant='bold'>{t('tech_error.not_available', { ns: 'badcases' })}</Title>
              <SubTitle>{t('tech_error.try_again', { ns: 'badcases', limit: '10' })}</SubTitle>
            </div>
          ) : (
            <>
              <Title className='green-gradiented-text' twStyle={tw`text-green-secondary`} variant='bold'>
                {t('gift_card.container_1.title', {
                  ns: 'landing',
                  nominal: `${Number(active?.amount).toLocaleString()} ₸`
                })}
              </Title>
              <div>
                <SubTitle twStyle={tw`text-secondary`} variant='medium'>
                  {t('gift_card.container_1.subtitle', { ns: 'landing', nominal: '10 000' })}
                </SubTitle>
                <div tw='grid grid-cols-2 gap-3 sm:max-w-max mt-5'>
                  {data?.data.products.map((item: { product_code: string; amount: string }, idx: number) => (
                    <NominalButton
                      data={item}
                      onClick={nominal => setActive(nominal)}
                      active={active}
                      key={`${item.product_code}${idx}`}
                    />
                  ))}
                </div>
              </div>
            </>
          )}
          <Button
            twStyle={tw`sm:max-w-max sm:w-auto w-full sm:mt-0 mt-[8px]`}
            variant='gradient'
            onClick={handleBuyCard}
            loading={isLoading}
            disabled={!active || Boolean(error)}
          >
            <span tw='text-s18'> {t('gift_card.container_1.button_text', { ns: 'landing' })}</span>
          </Button>
        </div>
        <img
          src={theme === 'dark' ? MegaSyiliqDark : MegaSyiliq}
          alt=''
          width={384}
          height={344}
          tw='absolute sm:bottom-0 -bottom-5 max-h-[344px] right-0'
        />
      </div>

      <BuyCardModal channel='landing' isBuyCard onClose={handleCloseModal} open={open} denomination={active} />
    </>
  )
}
const NominalButton = ({
  data,
  onClick,
  active
}: {
  data: { product_code: string; amount: string }
  onClick: (active: any) => void
  active: { product_code: string; amount: string } | null
}) => {
  return (
    <button
      tw='rounded-s32 sm:w-[126px] w-full h-[48px] py-3 bg-nominal font-semibold border border-grey'
      onClick={() => onClick(data)}
      style={{
        background:
          active?.product_code === data?.product_code
            ? `linear-gradient(259.92deg, rgba(56, 220, 113, 0.2) -3.68%, rgba(0, 129, 44, 0.2) 98.11%)`
            : ''
      }}
      css={[active?.product_code === data?.product_code && tw`bg-selector text-[#0ec94e] border border-[#0ec94e]`]}
    >
      <CurrencyFormat
        value={data.amount}
        displayType={'text'}
        format={parseInt(data.amount) < 100000 ? '## ######' : '### #####'}
      />
      ₸
    </button>
  )
}

export default LandingBuyCardContainer
